export default "__VITE_ASSET__CRBTMlm4__"